module.exports = __webpack_public_path__ + "img/bf95ff9.jpg";